import { campaignConstants } from '../constants'

export const campaignLoad = () => {
  return {
    type: campaignConstants.CAMPAIGN_LOAD
  }
}

export const campaignLoadSuccess = (payload) => {
  return {
    type: campaignConstants.CAMPAIGN_LOAD_SUCCESS,
    payload
  }
}

export const campaignLoadFailure = (payload) => {
  return {
    type: campaignConstants.CAMPAIGN_LOAD_FAILURE,
    payload
  }
}

export const campaignReset = () => {
  return {
    type: campaignConstants.CAMPAIGN_RESET
  }
}

export const campaignSave = (payload) => {
  return {
    type: campaignConstants.CAMPAIGN_SAVE,
    payload
  }
}

export const campaignSaveSuccess = (payload) => {
  return {
    type: campaignConstants.CAMPAIGN_SAVE_SUCCESS,
    payload
  }
}

export const campaignSaveFailure = (payload) => {
  return {
    type: campaignConstants.CAMPAIGN_SAVE_FAILURE,
    payload
  }
}

export const campaignDelete = (payload) => {
  return {
    type: campaignConstants.CAMPAIGN_DELETE,
    payload
  }
}

export const campaignDeleteSuccess = (payload) => {
  return {
    type: campaignConstants.CAMPAIGN_DELETE_SUCCESS,
    payload
  }
}

export const campaignDeleteFailure = (payload) => {
  return {
    type: campaignConstants.CAMPAIGN_DELETE_FAILURE,
    payload
  }
}

export const campaignBackToDraft = (payload) => {
  return {
    type: campaignConstants.CAMPAIGN_BACK_TO_DRAFT,
    payload
  }
}

export const campaignBackToDraftSuccess = (payload) => {
  return {
    type: campaignConstants.CAMPAIGN_BACK_TO_DRAFT_SUCCESS,
    payload
  }
}

export const campaignBackToDraftFailure = (payload) => {
  return {
    type: campaignConstants.CAMPAIGN_BACK_TO_DRAFT_FAILURE,
    payload
  }
}
